import { render, staticRenderFns } from "./MyDelegates.vue?vue&type=template&id=007acd8f&"
import script from "./MyDelegates.vue?vue&type=script&lang=js&"
export * from "./MyDelegates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports